import React, { useMemo, useEffect, useRef, useCallback } from 'react';
import { useDataWindow } from '../hooks/useDataWindow';

// ---- читаем globalFilters из localStorage ----
function getGlobalFilters() {
  try {
    const saved = localStorage.getItem('globalFilters');
    if (!saved) return { selectedGroups: [], startDate: null, endDate: null };
    const parsed = JSON.parse(saved);
    return {
      selectedGroups: Array.isArray(parsed.selectedGroups) ? parsed.selectedGroups : [],
      startDate: parsed.startDate || null,
      endDate: parsed.endDate || null,
    };
  } catch {
    return { selectedGroups: [], startDate: null, endDate: null };
  }
}

// ---- функция получения ISO-недели ----


const DataWindowSlider = ({ aggregation, numOfVisible = 100, actualDataLength = 0, onWindowChange, storageKey = 'dataWindow' }) => {
  console.log(actualDataLength)
  const globalFilters = getGlobalFilters();
  const [dataWindow, updateDataWindow] = useDataWindow(numOfVisible, null, storageKey); // shared hook
  
  // Debounced callback для загрузки данных
  const debounceTimerRef = useRef(null);
  const debouncedOnWindowChange = useCallback((start, end) => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    debounceTimerRef.current = setTimeout(() => {
      if (onWindowChange && typeof onWindowChange === 'function') {
        onWindowChange(start, end);
      }
    }, 300); // Задержка 300ms
  }, [onWindowChange]);

  // Используем реальную длину данных, если она передана, иначе вычисляем теоретическую
  const maxDataLength = useMemo(() => {
    if (actualDataLength > 0) {
      return actualDataLength;
    }

    if (!globalFilters) return 0;

    const start = globalFilters.startDate ? new Date(globalFilters.startDate) : new Date();
    const end = globalFilters.endDate ? new Date(globalFilters.endDate) : new Date();

    if (isNaN(start.getTime()) || isNaN(end.getTime())) return 0;

    const diffTime = Math.abs(end - start);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }, [globalFilters.startDate, globalFilters.endDate, actualDataLength]);

  const adjustedMaxDataLength = useMemo(() => {
    // Если у нас есть actualDataLength, используем его напрямую
    // (сервер уже агрегировал данные)
    if (actualDataLength > 0) {
      return actualDataLength;
    }
    
    // Иначе вычисляем теоретически (для обратной совместимости)
    const aggNum = Number(aggregation) || 1;
    return Math.ceil(maxDataLength / aggNum);
  }, [maxDataLength, aggregation, actualDataLength]);

  const windowSize = Math.min(numOfVisible, adjustedMaxDataLength - dataWindow.start);

  // Проверка: если диапазон < numOfVisible единиц, слайдер не отображается
  // Показываем слайдер, если данных больше чем четверть от numOfVisible (25)
  const showSlider = adjustedMaxDataLength >= Math.ceil(numOfVisible);

  // Отладочная информация (можно убрать в продакшене)
  // console.log('DataWindowSlider debug:', {
  //   actualDataLength,
  //   maxDataLength,
  //   aggregation,
  //   adjustedMaxDataLength,
  //   numOfVisible,
  //   showSlider
  // });

  const updateWindow = (value) => {
    const newStart = Number(value);
    const newEnd = Math.min(newStart + numOfVisible, adjustedMaxDataLength);
    
    updateDataWindow({ start: newStart, end: newEnd });
    
    // Вызываем debounced callback для загрузки данных
    debouncedOnWindowChange(newStart, newEnd);
  };

  // Убираем автоматический сброс при смене aggregation
  // Это должно контролироваться родительским компонентом
  
  // Очистка таймера при размонтировании
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  // ---- вычисляем текст диапазона дат ----
  

  if (!showSlider) {
    return null;
  }

  return (
    <div style={{ width: '100%',  marginBottom: 8, position: 'relative' }}>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '8px',
          backgroundColor: '#eee',
          borderRadius: '4px',
        }}
      >
        <div
          style={{
            position: 'absolute',
            height: '100%',
            left: `${(dataWindow.start / adjustedMaxDataLength) * 100}%`,
            width: `${(windowSize / adjustedMaxDataLength) * 100}%`,
            backgroundColor: '#1976d2',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        />
      </div>
      <input
        type="range"
        min={0}
        max={Math.max(0, adjustedMaxDataLength - (numOfVisible - 1))}
        step={1}
        value={dataWindow.start}
        onChange={(e) => updateWindow(Number(e.target.value))}
        style={{
          width: '100%',
          opacity: 0,
          height: '8px',
          cursor: 'pointer',
          position: 'relative',
          zIndex: 2,
          transform: 'translate(0%,-150%)',
        }}
      />
      
    </div>
  );
};

export default DataWindowSlider;
